import React from "react";
import ExcelJS from "exceljs"; 
import { toast } from "react-toastify";

export const ExportUsersExcel = ({ filteredData, corporationDetails = [] }) => {
    const exportToExcel = async () => {
        try {
            let usersData = filteredData;

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Users");

            const boldFont = { bold: true };

            const currentDate = new Date();
            const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
            const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
            const downloadDateTime = `Users Details Generated on: ${formattedDate}, ${formattedTime}`;

            // Header row 1 — date/time
            worksheet.addRow(["", "", downloadDateTime, ""]);
            worksheet.mergeCells(1, 2, 1, 7);
            worksheet.getCell(1, 2).value = downloadDateTime;
            worksheet.getCell(1, 2).font = boldFont;
            worksheet.getCell(1, 2).alignment = { horizontal: "center" };

            // Header row 2 — title
            let rowIndex = 2;
            const titleText = filteredData && filteredData.length > 0 ? "Users" : "All Users";
            worksheet.addRow(["", "", titleText, ""]);
            worksheet.mergeCells(rowIndex, 2, rowIndex, 7);
            worksheet.getCell(rowIndex, 2).value = titleText;
            worksheet.getCell(rowIndex, 2).font = boldFont;
            worksheet.getCell(rowIndex, 2).alignment = { horizontal: "center" };
            rowIndex++;

            // Table header row
            const tableHeaderRow = worksheet.addRow([
                "S.No",
                "User Name",
                "Employee Code",
                "Email",
                "Mobile No",
                "Corporation",
                "Status",
            ]);

            tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                cell.font = boldFont;
                cell.alignment = { horizontal: "center" };
                if (colNumber >= 1 && colNumber <= 7) {
                    cell.fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "F6B1B1" },
                        bgColor: { argb: "FFFFFFFF" },
                    };
                }
            });

            // Data rows
            usersData.forEach((user, index) => {
                const corp = corporationDetails.find(
                    (c) => c.corporationId === (user.organizationId || user.corporationId)
                );
                const corporationName = corp?.corporationName || user.corporationName || "-";

                worksheet.addRow([
                    index + 1,
                    user.userName || "N/A",
                    user.employeeCode || "N/A",
                    user.emailId || "N/A",
                    user.mobileNumber || "N/A",
                    corporationName,
                    user.isActive ? "Active" : "InActive",
                ]).eachCell({ includeEmpty: true }, (cell) => {
                    cell.alignment = { horizontal: "center" };
                });
            });

            // Column widths
            worksheet.columns = [
                { width: 5 },   // S.No
                { width: 25 },  // User Name
                { width: 20 },  // Employee Code
                { width: 28 },  // Email
                { width: 15 },  // Mobile No
                { width: 25 },  // Corporation
                { width: 12 },  // Status
            ];

            // Save the workbook to a file
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `Users.xlsx`;
            a.click();
            URL.revokeObjectURL(url);


        } catch (error) {
            console.error("Error generating Excel file:", error);
            toast.error("Error exporting users data", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
            });
        }
    };

    return (
        <button
            className="button-container"
            onClick={exportToExcel}
        >
            <i className="fa-solid fa-file-excel me-1 icon-container"></i>
            Excel
        </button>
    );
};